import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ({ items }: { items: FAQItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((item, i) => (
        <div
          key={i}
          className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
        >
          <button
            onClick={() => setOpenIndex(openIndex === i ? null : i)}
            className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100/50 transition-colors"
          >
            <span className="font-heading text-base font-semibold text-foreground-900 pr-4">
              {item.question}
            </span>
            <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
              openIndex === i ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
            }`}>
              <i className="ri-add-line text-sm"></i>
            </div>
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}